import { render, staticRenderFns } from "./DutySettingsModal.vue?vue&type=template&id=66be0dc2"
import script from "./DutySettingsModal.vue?vue&type=script&lang=ts"
export * from "./DutySettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports